import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { CKButton } from 'clearkit';
import { Fragment } from 'react';

import Footer from '~/components/Footer';
import TextField from '~/components/RedesignedTextField';

import CheckboxActive from './CheckboxActive.svg';
import CheckboxInactive from './CheckboxInactive.svg';
import styles from './styles';

function PlanOption({ name, description, classes, checked, onChange }) {
  return (
    <div className={classes.planOption}>
      <Checkbox
        checked={checked}
        checkedIcon={<CheckboxActive />}
        classes={{ root: classes.checkbox }}
        icon={<CheckboxInactive />}
        onChange={(event) => onChange(event.target.checked)}
        value={name.toLowerCase()}
      />
      <div>
        <span className={classes.optionName}>{name}</span>
        <p className={classes.optionDescription}>{description}</p>
      </div>
    </div>
  );
}

export function isValid(values) {
  const anOptionSelected =
    values.advertising ||
    values.personalization ||
    values.alerting ||
    values.enrichment_salesforce ||
    values.enrichment_hubspot ||
    values.enrichment_marketo ||
    values.enrichment_segment;

  return values.email !== '' && values.name !== '' && anOptionSelected;
}

function RequestAccessForm({
  classes,
  values,
  onChange,
  onClose,
  valid,
  onSubmit,
  product,
}) {
  return (
    <form onSubmit={onSubmit} className={classes.formOuter}>
      <div className={classes.body}>
        <div className={classes.formInner}>
          <div className={classes.contactInfo}>
            <FormControl fullWidth className={classes.field}>
              <FormLabel>Email address*</FormLabel>
              <TextField
                onChange={(event) => onChange('email', event.target.value)}
                value={values.email}
              />
            </FormControl>

            <FormControl fullWidth className={classes.field}>
              <FormLabel>Name*</FormLabel>
              <TextField
                onChange={(event) => onChange('name', event.target.value)}
                value={values.name}
              />
            </FormControl>
          </div>

          <div className={classes.planOptions}>
            <p className={classes.choosePlan}>
              Choose the plans you&apos;d like to add to your account
            </p>
            {product === 'dataEnrichment' ? (
              <Fragment>
                <PlanOption
                  name="Salesforce enrichment"
                  description="Enrich any account, contact, or lead, or your full database of records, within Salesforce."
                  classes={classes}
                  onChange={(value) => onChange('enrichment_salesforce', value)}
                  checked={values.enrichment_salesforce}
                />

                <PlanOption
                  name="Clearbit for Marketo"
                  description="Enrich any account, contact, or lead, or your full database of records, within Marketo."
                  classes={classes}
                  onChange={(value) => onChange('enrichment_marketo', value)}
                  checked={values.enrichment_marketo}
                />

                <PlanOption
                  name="Clearbit for Hubspot"
                  description="Enrich and refresh new contacts, form submissions, or your entire contact database within HubSpot."
                  classes={classes}
                  onChange={(value) => onChange('enrichment_hubspot', value)}
                  checked={values.enrichment_hubspot}
                />

                <PlanOption
                  name="Clearbit for Segment"
                  description="Enrich people and companies in Segment with Clearbit data."
                  classes={classes}
                  onChange={(value) => onChange('enrichment_segment', value)}
                  checked={values.enrichment_segment}
                />
              </Fragment>
            ) : (
              <Fragment>
                <PlanOption
                  name="Alerting"
                  description="Send alerts to your team via destinations like Slack, Salesforce, Email or Webhooks when a person or company matches an audience."
                  classes={classes}
                  onChange={(value) => onChange('alerting', value)}
                  checked={values.alerting}
                />

                <PlanOption
                  name="Advertising"
                  description="Automatically create highly targeted ads audiences when a person or company matches an audience."
                  classes={classes}
                  onChange={(value) => onChange('advertising', value)}
                  checked={values.advertising}
                />

                <PlanOption
                  name="Personalization"
                  description="Use Clearbit Audiences to customize your website in realtime."
                  classes={classes}
                  onChange={(value) => onChange('personalization', value)}
                  checked={values.personalization}
                />
              </Fragment>
            )}
          </div>

          <div className={classes.message}>
            <FormControl fullWidth className={classes.field}>
              <FormLabel>Message</FormLabel>
              <TextField
                onChange={(event) => onChange('message', event.target.value)}
                placeholder="Let us know a little more about what you're aiming to accomplish and if you have any additional requirements."
                value={values.message}
                multiline
                rows={3}
                InputProps={{ rel: 'message' }}
              />
            </FormControl>
          </div>
        </div>
      </div>
      <Footer
        right={
          <>
            <CKButton onClick={onClose}>Cancel</CKButton>
            <CKButton
              variant="bold"
              variantColor="blue"
              isDisabled={!valid}
              type="submit">
              Submit
            </CKButton>
          </>
        }
      />
    </form>
  );
}

RequestAccessForm.propTypes = {
  classes: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  values: PropTypes.object,
  onChange: PropTypes.func,
  valid: PropTypes.bool,
};

export default withStyles(styles)(RequestAccessForm);
